export { default } from "./ArticleIcon";
